module.exports = __webpack_public_path__ + "img/2024-08.927ce4dd.jpg";